import React from 'react';
import Slide from '@material-ui/core/Slide';

const Transition = props => {
  return <Slide direction="right" {...props} />;
};

export default Transition;
